/* eslint-disable spaced-comment */
/// <reference path="./types.d.ts" />

import type { StringDictionary } from '@bingads-webui/http-util';

export const FilePickerStringMap: StringDictionary = {
  FilePicker_ExploreFile: _TL_('Browse'),
  FilePicker_RemoveFile: _TL_('Remove'),
  FilePicker_AddNewFile: _TL_('Add another file'),
  FilePicker_Placeholder: _TL_('Browse...'),
  FilePicker_ErrorMessage_Required: _TL_('This field is required'),
  FilePicker_ErrorMessage_ExtensionNotAllowed: _TL_('The uploaded file type is not supported.'),
  FilePicker_ErrorMessage_ExtensionNotAllowed_WithAllowedExtensions: _TL_('The uploaded file type is not supported. Please upload a file of type(s): {{allowedFileExtensions}}'),
  FilePicker_ActionMessage_FileAdded: _TL_('File selected'),
  FilePicker_ActionMessage_FileChanged: _TL_('File changed'),
  FilePicker_ActionMessage_FileRemoved: _TL_('File removed'),
};

export type FilePickerStringMapType = typeof FilePickerStringMap;
export type FilePickerStringMapKey = keyof FilePickerStringMapType;
